// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { StateType, DispatchType } from "../../../global/types/redux";
import { uploadFile, faceVerify } from "../../actions/faceActions";
import FaceVerifyLayout from "../../components/facesearch/FaceVerifyLayout";

class FaceVerify extends Component<*> {
  uploadFile = (
    file: File | Blob,
    completeCall: Function,
    errorCall: Function
  ): * => {
    this.props.actions.uploadFile(file, completeCall, errorCall, true);
  };

  faceVerify = (
    leftFaces: Array<*>,
    rightFaces: Array<*>,
    doneCall: Function
  ): * => {
    this.props.actions.faceVerify(leftFaces, rightFaces, doneCall);
  };

  render(): React$Element<*> {
    return (
      <FaceVerifyLayout
        detectedFaces={this.props.faceSearch.detectedFaces}
        uploadFile={this.uploadFile}
        faceVerify={this.faceVerify}
      />
    );
  }
}

const mapStateToProps = (state: StateType): * => ({
  faceSearch: state.v3account.faceSearch
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators({ faceVerify, uploadFile }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(FaceVerify);
